import { render, staticRenderFns } from "./teamMember-v2.vue?vue&type=template&id=1a3a9a6c&scoped=true&"
import script from "./teamMember-v2.vue?vue&type=script&lang=js&"
export * from "./teamMember-v2.vue?vue&type=script&lang=js&"
import style0 from "./teamMember-v2.vue?vue&type=style&index=0&id=1a3a9a6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3a9a6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a3a9a6c')) {
      api.createRecord('1a3a9a6c', component.options)
    } else {
      api.reload('1a3a9a6c', component.options)
    }
    module.hot.accept("./teamMember-v2.vue?vue&type=template&id=1a3a9a6c&scoped=true&", function () {
      api.rerender('1a3a9a6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22J9akXhfqEUQ/JS/teamMember-v2.vue"
export default component.exports